import {searchReportHTML, searchReport, searchReportById} from '../reports/reports.api';

// #region Globals
const CONTEXT_BASE_PATH = 'obraspublicas/pdf';
const CONTEXT_BASE_HTML_PATH = 'obraspublicas/html';
const CONTEXT_SINGLE_BASE_PATH = 'obraspublicas/pdfindividual';
// #endregion

// #region Public functions
async function getPublicWorkPdf(id) {
  return searchReportById(id, CONTEXT_SINGLE_BASE_PATH);
}
async function searchPublicWorkPdf(searchParams = {}) {
  return searchReport(searchParams, CONTEXT_BASE_PATH);
}
async function searchPublicWorkHtml(searchParams = {}) {
  return searchReportHTML(searchParams, CONTEXT_BASE_HTML_PATH);
}

// #endregion

// #region Private functions
// ...
// #endregion

export {
  getPublicWorkPdf,
  searchPublicWorkPdf,
  searchPublicWorkHtml,
};
